import classNames from "classnames";
import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";
import ResourceResolver from "../../../../../lib/UniversalTable/ResourceResolver";
import ContentSection from "../../../common/ContentSection";
import PageTitle from "../../../common/PageTitle";
import UniversalTableLiteWeb from "../../../common/UniversalTableLiteWeb";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";
import LandingTypography from "../../../landingPage/pages/Homepage/components/LandingTypography";

const StocksTable = ({ translate }) => {
  const isDesktop = useIsDesktop();

  return (
    <LandingTypography>
      <ContentSection>
        <PageTitle title={translate("stocks_table_page_title")} />
        <h1
          className={
            "normal-case text-2xl text-black line-height-130 font-bold mb-4"
          }
        >
          {translate("stocks_table_page_header")}
        </h1>
        <p
          className={classNames("text-black line-height-150", {
            "text-sm  mb-4": isDesktop,
            "text-base  mb-6": !isDesktop
          })}
          dangerouslySetInnerHTML={{
            __html: translate("stocks_table_page_description")
          }}
        />
        <UniversalTableLiteWeb
          resourceId={ResourceResolver["stocks_list"]}
          useUrlSettings
        />
      </ContentSection>
    </LandingTypography>
  );
};

export default withTranslations(StocksTable);
